import React, { useState, useRef } from 'react'
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api'
import { sendRegister } from '../../apis/register'
import './contacts.scss'

export default function Contacts() {
  const [form, setForm] = useState({ name: '', email: '', message: '' })
  const [errors, setErrors] = useState({})
  const [sent, setSent] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [sentEmail, setSentEmail] = useState('')
  const successRef = useRef(null)

  const validate = () => {
    const e = {}
    if (!form.name.trim()) e.name = 'El nombre es requerido.'
    if (!form.email.trim()) e.email = 'El correo es requerido.'
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = 'Ingresa un correo válido.'
    if (!form.message.trim()) e.message = 'Por favor deja un mensaje.'
    return e
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setForm((prev) => ({ ...prev, [name]: value }))
    setErrors((prev) => ({ ...prev, [name]: undefined }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const eform = validate()
    if (Object.keys(eform).length) return setErrors(eform)
    setSubmitting(true)
    try {
      await sendRegister(form)
      setSentEmail(form.email)
      setSent(true)
      setForm({ name: '', email: '', message: '' })
      // move focus to success message for screen readers
      setTimeout(() => successRef.current?.focus(), 100)
    } catch (err) {
      const errorMsg = err.response?.data?.message || 'Error al enviar. Intenta de nuevo.'
      setErrors({ submit: errorMsg })
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <section className="contacts">
      <div className="contacts__container">
        <div className="contacts__info">
          <h2 className="contacts__title">Contacto</h2>
          <p className="contacts__lead">¿Tienes un proyecto o una idea? Hablemos. Rellena el formulario o escríbenos</p>
          <ul className="contacts__cards">
            {/* <li>
              <strong>Email</strong>
              <a href="mailto:info@ingeniosoft.dev">info@ingeniosoft.dev</a>
            </li>
            <li>
              <strong>Teléfono</strong>
              <a href="tel:+123456789">+57 300 000 0000</a>
            </li> */}
            <li>
              <strong>Oficina</strong>
              <address>Medellín, Colombia</address>
            </li>
          </ul>

          <div className="contacts__social">
            <a href="#" aria-label="Visitar LinkedIn" className="social-link">LinkedIn</a>
            <a href="#" aria-label="Visitar GitHub" className="social-link">GitHub</a>
          </div>

          <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
            <GoogleMap
              mapContainerClassName="contacts__map"
              center={{ lat: 6.2442, lng: -75.5898 }}
              zoom={13}
            >
              <Marker
                position={{ lat: 6.2442, lng: -75.5898 }}
                title="Medellín, Colombia"
              />
            </GoogleMap>
          </LoadScript>
        </div>

        <div className="contacts__form-wrapper">
          {sent ? (
            <div
              className="contacts__success"
              role="status"
              tabIndex={-1}
              ref={successRef}
              aria-live="polite"
            >
              <div className="success__content">
                <div className="success__icon-wrapper">
                  <svg className="success__icon" width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                    <path d="M8 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <h3>¡Mensaje enviado!</h3>
                <p>Gracias por escribirnos. Hemos recibido tu mensaje y te responderemos pronto a <strong>{sentEmail}</strong>.</p>
                <p className="success__note">También te hemos enviado un correo de confirmación.</p>
                <button 
                  className="btn-secondary" 
                  onClick={() => setSent(false)}
                  type="button"
                >
                  Enviar otro mensaje
                </button>
              </div>
            </div>
          ) : (
            <form className="contacts__form" onSubmit={handleSubmit} noValidate>
              <div className="field">
                <label htmlFor="name">Nombre</label>
                <input id="name" name="name" type="text" value={form.name} onChange={handleChange} aria-required="true" aria-invalid={!!errors.name} />
                {errors.name && <div className="field__error" role="alert">{errors.name}</div>}
              </div>

              <div className="field">
                <label htmlFor="email">Correo Electrónico</label>
                <input id="email" name="email" type="email" value={form.email} onChange={handleChange} aria-required="true" aria-invalid={!!errors.email} />
                {errors.email && <div className="field__error" role="alert">{errors.email}</div>}
              </div>

              <div className="field">
                <label htmlFor="message">Mensaje</label>
                <textarea id="message" name="message" rows={5} value={form.message} onChange={handleChange} aria-required="true" aria-invalid={!!errors.message} />
                {errors.message && <div className="field__error" role="alert">{errors.message}</div>}
              </div>

              {errors.submit && <div className="field__error" role="alert">{errors.submit}</div>}

              <div className="form-actions">
                <button className="btn-primary" type="submit" disabled={submitting}>{submitting ? 'Enviando...' : 'Enviar mensaje'}</button>
              </div>

              <p className="contacts__hint">Al enviar aceptas que guardemos tus datos para responder tu consulta. No compartimos información.</p>
            </form>
          )}
        </div>
      </div>
    </section>
  )
}